module.exports = __webpack_public_path__ + "static/media/WatchedIcon.0ee3a044.png";